import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import service1 from "../assets/service_1.png";
import service2 from "../assets/service_2.png";
import service3 from "../assets/service_3.png";

const Services = () => {
  const services = [
    {
      title: "Auto",
      description:
        "Get Affordable auto rides. Request a Thaani and ride comfortably around your town.",
      img: service1
    },
    {
      title: "Taxi",
      description:
        "Book a taxi instantly and enjoy fares lower than the market average.",
      img: service2
    },
    {
      title: "Parcel / Delivery",
      description:
        "Book your parcel today and enjoy lightning-fast service at unbeatable prices.",
      img: service3
    }
  ]; // Replace with your image path // Replace with your image path // Replace with your image path

  return (
    <div className="container my-5 text-center">
      <h3 className="fw-bold">Thaani - Your Local Companion</h3>
      <p className="text-warning fs-5">
        Grab your favorite local travel mode and enjoy!
      </p>

      <div className="row g-4">
        {services.map((service, index) =>
          <div className="col-12 col-md-4" key={index}>
            <div
              className="p-3 h-100 rounded"
              style={{ border: "1px solid #FCB027" }}
            >
              <div className="row">
                <div className="col-4">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="mb-3"
                    style={{ width: "80px", height: "80px" }}
                  />
                </div>
                <div className="col-8 text-start">
                  <h5 className="fw-bold">
                    {service.title}
                  </h5>
                  <p className="text-muted small">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
